function lazyload(target, source, sourceAttribute = "src") {
  if (typeof window !== "undefined" && "IntersectionObserver" in window) {
    const observer = new window.IntersectionObserver((entries, self) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        entry.target.setAttribute(sourceAttribute, source);
        self.unobserve(entry.target);
      }
    });
    observer.observe(target);
  } else {
    target.setAttribute(sourceAttribute, source);
  }
}
export {
  lazyload
};
//# sourceMappingURL=lazyload.js.map
